import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import styles from "../../screens/PostSearch/PostRequirement.module.css";
import { PiFileTextThin } from "react-icons/pi";
import { PiMailboxLight } from "react-icons/pi";
import { CiMobile3 } from "react-icons/ci";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
const MatchesResultPublicResume = ({
  name,
  job,
  location,
  salary,
  skills,
  btn1,
  btn2,
  matches,
}) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpandClick = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <Box className={styles.matches_resume_result}>
      <Box>
        <Typography
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <b>Profile Verified</b>
        </Typography>
        <Typography style={{ alignSelf: "flex-end" }}>
          {" "}
          <b>{matches}</b>
        </Typography>
      </Box>
      <Box sx={{ backgroundColor: "#fff !important" }}>
        <span>
          <Typography>
            Candidate Name: <b>{name}</b>
          </Typography>
          <Typography>
            Job Profile: <b>{job}</b>
          </Typography>
          <Typography>
            Location: <b>{location}</b>
          </Typography>
          <Typography>
            Salary: <b>{salary} </b>
          </Typography>
          <Typography sx={{ display: "flex" }}>
            {" "}
            Excellency in skills:{" "}
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                paddingLeft: "5px",
              }}
            >
              {" "}
              <b>{skills}</b>
              {isExpanded && (
                <b>
                  Hibernate 2 Years | Spring Boot 4 Years | ASW Cloud 2 Years |
                  GO 2 Years
                </b>
              )}
            </span>
            <span style={{ marginLeft: "10px" }} onClick={handleExpandClick}>
              {isExpanded ? <IoIosArrowUp /> : <IoIosArrowDown />}
            </span>
          </Typography>
        </span>

        <span style={{ alignSelf: "flex-end" }}>
          <span
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 10px 0 40px",
            }}
          >
            <Typography>
              <div
                style={{
                  backgroundColor: "#e1eaf0",
                  cursor: "pointer",
                  borderRadius: "3px ",
                }}
              >
                <PiFileTextThin style={{ fontSize: "22px" }} />
              </div>
            </Typography>
            <Typography>
              <div
                style={{
                  backgroundColor: "#e1eaf0",
                  cursor: "pointer",
                  borderRadius: "3px ",
                }}
              >
                <CiMobile3 style={{ fontSize: "22px" }} />
              </div>
            </Typography>
            <Typography>
              <div
                style={{
                  backgroundColor: "#e1eaf0",
                  cursor: "pointer",
                  borderRadius: "3px ",
                }}
              >
                <PiMailboxLight style={{ fontSize: "22px" }} />
              </div>
            </Typography>
          </span>
          <div style={{ marginTop: "50px", backgroundColor: "white" }}>
            <button onClick={() => navigate("/candidate-view-resume")}>
              {" "}
              {btn1}
            </button>
            <button style={{ marginLeft: "10px" }}>{btn2}</button>
          </div>
        </span>
      </Box>
    </Box>
  );
};

export default MatchesResultPublicResume;
